import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/common/not-found/not-found.component';
import { urlRoutes } from './core/constants/url-route.constant';
import { AuthGuard } from './core/guard/auth.guard';
import { AuthenticatedGuard } from './core/guard/authenticated.guard';
import { SignUpComponent } from './views/agent-master/agents/sign-up/sign-up.component';
import { UnauthorisedComponent } from './views/components/unauthorised/unauthorised.component';
import { DocViewersComponent } from './views/components/doc-viewers/doc-viewers.component';
import { DynamicFormBuildComponent } from './views/dynamic-form-build/dynamic-form-build.component';
import { SsoLoginComponent } from './views/authentication/sso-login/sso-login.component';

const routes: Routes = [
    // TODO: we are using the below path for temporary purpose
    {
        path: '',
        redirectTo: urlRoutes.mainLayout,
        pathMatch: 'full',
    },
    {
        path: urlRoutes.authentication,
        loadChildren: () =>
            import('./views/authentication/authentication.module').then(
                (m) => m.AuthenticationModule
            ),
        canActivate: [AuthenticatedGuard]
    },
    { path: 'ssoLogin', component: SsoLoginComponent },
    {
        path: urlRoutes.mainLayout,
        loadChildren: () =>
            import('./views/layout/layout.module').then((m) => m.LayoutModule),
        canActivate: [AuthGuard]
    },
    { path: 'agent-signup', component: SignUpComponent },
    { path: 'unauthorised', component: UnauthorisedComponent },
    { path: 'doc', component: DocViewersComponent },
    // This line will remain down from the whole pages component list
    { path: '**', component: NotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    declarations: [
    
    DynamicFormBuildComponent
  ],
})
export class AppRoutingModule { }
